export enum TermAddLineBreakMode {
  lineBreak = "linebreak",
  nextRow = "nextRow",
}

const lineBreakModeKey = "TermAddLineBreakMode";
const duplicatedCheckKey = "TermAddDuplicatedCheck";
const showingMemoKey = "TermAddShowingMemo";
const showingPronunciationKey = "TermAddShowingPronunciation";

// 모바일 앱과 같은 기본값을 쓴다 (줄바꿈, 중복 단어 알림 켬, 설명·발음 칸 표시)
export function getTermAddLineBreakModeFromLocalStorage(): TermAddLineBreakMode {
  const value = localStorage.getItem(lineBreakModeKey);
  return value === TermAddLineBreakMode.nextRow
    ? TermAddLineBreakMode.nextRow
    : TermAddLineBreakMode.lineBreak;
}

export function setTermAddLineBreakModeToLocalStorage(
  mode: TermAddLineBreakMode
) {
  localStorage.setItem(lineBreakModeKey, mode);
}

export function isOnTermAddDuplicatedCheckFromLocalStorage(): boolean {
  return getBoolean(duplicatedCheckKey, true);
}

export function setTermAddDuplicatedCheckToLocalStorage(isOn: boolean) {
  localStorage.setItem(duplicatedCheckKey, String(isOn));
}

export function isShowingTermAddMemoFromLocalStorage(): boolean {
  return getBoolean(showingMemoKey, true);
}

export function setTermAddShowingMemoToLocalStorage(isShow: boolean) {
  localStorage.setItem(showingMemoKey, String(isShow));
}

export function isShowingTermAddPronunciationFromLocalStorage(): boolean {
  return getBoolean(showingPronunciationKey, true);
}

export function setTermAddShowingPronunciationToLocalStorage(isShow: boolean) {
  localStorage.setItem(showingPronunciationKey, String(isShow));
}

function getBoolean(key: string, defaultValue: boolean): boolean {
  const value = localStorage.getItem(key);
  if (value === null) {
    return defaultValue;
  }
  return value === "true";
}
